var _polygon;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Back_1",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    xmlns: "http://www.w3.org/2000/svg",
    width: "25px",
    height: "25px",
    viewBox: "0 0 42 42",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    points: "27.066,1 7,21.068 26.568,40.637 31.502,35.704 16.865,21.068 32,5.933 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.4858a318cdb360a89ab0aa94c7b681b3.svg";
export { ForwardRef as ReactComponent };